/**
 * Returns a filtered list of data types based on the sensor type id.
 * @param {number} sensorTypeId
 * @param {string[]} dataTypes
 * @returns {string[]}
 */
function getDefaultVisibleDataTypes(units, dataTypes = []) {
  // Loop through all units and their connected sensors and check sensor types.
  let visibleDataTypes = [];

  for (const Unit of units) {
    const unitDataTypes =
      Unit?.RecordedDataTypes?.map((rdt) => rdt.DataTypes)?.flat() || [];
    for (const UnitSensor of Unit.UnitSensors || []) {
      const sensor = UnitSensor.Sensor;
      if (!sensor) {
        visibleDataTypes.push(...unitDataTypes);
        continue;
      }
      const sensorType = sensor.SensorType;
      if (!sensorType) {
        visibleDataTypes.push(...unitDataTypes);
        continue;
      }

      switch (sensorType) {
        case 'PowerMoniMain':
          visibleDataTypes.push('power');
          break;
        case 'PowerMoniSpot':
          if (sensor.CalibrationType !== 'Level1') {
            visibleDataTypes.push('power');
          } else {
            visibleDataTypes.push('uncalibrated-current');
          }
          break;
        case 'HeatMoniSpot':
          visibleDataTypes.push('temperature');
          break;
        case 'TempMoniSpot':
          visibleDataTypes.push('temperature');
          break;

        case 'FlowMoniVolume':
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('indicative-consumption');
          visibleDataTypes.push('uncalibrated-accumulated-flow');
          visibleDataTypes.push('uncalibrated-flow-speed');
          break;

        case 'TempMoniDC':
          visibleDataTypes.push('temperature');
          break;
        case 'FlowMoniEnergy':
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('indicative-consumption');
          visibleDataTypes.push('uncalibrated-accumulated-flow');
          visibleDataTypes.push('uncalibrated-flow-speed');
          break;
        case 'GateWaySensor':
          visibleDataTypes.push('temperature');
          visibleDataTypes.push('humidity');
          visibleDataTypes.push('co2-consumption');
          break;
        default:
          visibleDataTypes = dataTypes;
      }
    }
  }

  if (visibleDataTypes.length === 0) {
    visibleDataTypes = dataTypes;
  }

  return Array.from(new Set(visibleDataTypes));
}

export default getDefaultVisibleDataTypes;
